import React from 'react';
import { useEffect } from 'react';
import { useNavigate  } from 'react-router-dom';
import LogoPic from "../Assets/Images/logo.png";
import API from "../Services/API";
import {toast} from "react-toastify";


export default function Splash(props) {
    const navigate = useNavigate();

    useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if(token) {
            API.checkUser()
                .then((response) => {
                    if(response.is_valid) {
                        const count = window.localStorage.getItem("_c");
                        if (count && count > 0) {
                            navigate('/book-shipment');
                        }
                        else {
                            navigate('/requests');
                        }

                    }
                    else {
                        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                        navigate('/login');
                    }
                })

        }
        else {
            navigate('/login');
        }

    }, [navigate]);

    return (
        <React.Fragment>
            <section className="container-fluid splash " >

                <div className="row">
                    <div className="col-12 mt-4 ">
                        <div>
                            <img src={LogoPic} alt="CheapShip" className="rounded mx-auto d-block mt-5 " />
                        </div>
                    </div>
                    <h2 className="col-12 text-center title text-white fw-bold mt-5">
                       Cheap Ship
                    </h2>
                    <div className="col-12 text-center fixed-bottom pb-5 mb-4">
                        <div className="spinner-border text-white-50 mb-2" role="status">

                        </div>

                    </div>

                </div>
            </section>
        </React.Fragment>
    );
}
